(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('customPagination', CustomPagination);

    /** @ngInject */
    function CustomPagination($rootScope, PATHS) {
        function CustomPaginationController() {
            const vm = this;

            vm.onClick = pageData => {
                vm.onPageClick()(pageData);
            }
        }

        function link(scope, attrs, elem, ctrl) {
            let pages = [];
            let start = 1;
            let end;

            if (!ctrl.displayedPages)
                ctrl.displayedPages = 5;

            if ($rootScope.isMobile)
                ctrl.displayedPages = 2;

            start = Math.max(start, ctrl.currentPage - Math.abs(Math.floor(ctrl.displayedPages / 2)));
            end = start + ctrl.displayedPages;

            if (end > ctrl.numberOfPages) {
                end = ctrl.numberOfPages + 1;
                start = Math.max(1, end - ctrl.displayedPages);
            }

            for (let i = start; i < end; i++)
                pages.push(i);

            ctrl.pages = pages;
        }

        return {
            bindToController: true,
            link: link,
            controller: CustomPaginationController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/custom-pagination/custom-pagination.html`,
            scope: {
                onPageClick: '&',
                numberOfPages: '=',
                currentPage: '=',
                displayedPages: '=?'
            }
        }
    }
}());